module.exports = __webpack_public_path__ + "static/media/mapArrow.754cb8cb.svg";